'use client'

import { useTranslations } from 'next-intl'

import { ContentForm } from '../../ContentForm'
import {
	qrNameFormConfig,
	TQrContentFormSection,
} from '../../contentFormSections'
import { plainTextFormConfig } from '../../contentFormSections/PlainTextForm'
import { QR_TYPE, TContentFormProps } from '../../generatorTypes'

export const PlainTextContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			plainTextFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.PlainText} config={config} {...props} />
}
